import Tabs from '../../../components/Tabs/Tabs'
import AsistenciasPendientes from './tabs/Asistencias/AsistenciasPendientes'
import PruebasPendientes from './tabs/Pruebas/PruebasPendientes'
import css from './Asistencias.module.css'

const Asistencias = () => {
  return (
    <Tabs
      className={css.tabs}
      tabs={[
        { name: 'Asistencias', content: <AsistenciasPendientes /> },
        { name: 'Pruebas', content: <PruebasPendientes /> }
      ]}
    />
  )
}

export default Asistencias
